/**
 * Forecast versus Budget (FSD 2.2.5.10): a revised forecast against the budget in force.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_PERMISSIONS } from '@/modules/budget/permissions'

export const BUDGET_FORECAST_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/forecast-vs-budget',
    name: 'budget-forecast-vs-budget',
    component: () => import('@/modules/budget/forecast/ForecastVsBudgetView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetForecastVsBudget',
      permission: BUDGET_PERMISSIONS.varianceRead,
    },
  },
]

export function forecastVsBudgetRoute(scope: {
  companyId: number
  fiscalYear: number
  forecastVersionId?: number | null
}): string {
  const params = new URLSearchParams()
  params.set('companyId', String(scope.companyId))
  params.set('fiscalYear', String(scope.fiscalYear))
  if (scope.forecastVersionId != null) params.set('forecastVersionId', String(scope.forecastVersionId))
  return `/budget/forecast-vs-budget?${params.toString()}`
}
